import React from "react";

// reactstrap
import { Row, Col } from "reactstrap";

// images import
import img_coding from "../../public/images/coding.png";
import img_mysql from "../../public/images/mysql.png";
import img_git from "../../public/images/git.png";
import img_excel from "../../public/images/excel.png";
import img_postman from "../../public/images/postman.png";
import img_compass from "../../public/images/compass.png";

// animations
import Fade from "react-reveal/Fade";
import Flip from "react-reveal/Flip";

function Tools() {
  const toolsData1 = [
    {
      title: "Visual Studio Code",
      imgSrc: img_coding,
      imgAlt: "coding.png",
    },
    {
      title: "MySQL Workbench",
      imgSrc: img_mysql,
      imgAlt: "mysql.png",
    },
    {
      title: "Git Version Control",
      imgSrc: img_git,
      imgAlt: "git.png",
    },
  ];

  const toolsData2 = [
    {
      title: "Microsoft Office",
      imgSrc: img_excel,
      imgAlt: "excel.png",
    },
    {
      title: "Postman",
      imgSrc: img_postman,
      imgAlt: "postman.png",
    },
    {
      title: "MongoDB Compass",
      imgSrc: img_compass,
      imgAlt: "compass.png",
    },
  ];

  const ToolsRow = ({ toolsData }) => {
    return (
      <Row className="justify-content-center">
        {toolsData.map((tools, idx) => {
          return (
            <Col sm="4" xs="6" className="mt-5" key={idx}>
              <Flip left>
                <div>
                  <img
                    src={tools.imgSrc}
                    alt={tools.imgAlt}
                    width="25%"
                    loading="lazy"
                  />
                  <span className="d-block tools-item-title mt-3 mb-2">
                    {tools.title}
                  </span>
                </div>
              </Flip>
            </Col>
          );
        })}
      </Row>
    );
  };

  return (
    <div className="tools-container text-center m-auto">
      <div className="component-top-margin">
        <Fade up>
          <h1 className="common-component-title">TOOLS I USE</h1>
        </Fade>
        <ToolsRow toolsData={toolsData1} />
        <ToolsRow toolsData={toolsData2} />
      </div>
    </div>
  );
}

export default Tools;
